var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h2", [_vm._v(_vm._s(_vm.$ct("what-layout-heading-data")))]),
      _c(
        "w-row",
        { attrs: { stretch: "" } },
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { fancy: "", label: _vm.$ct("company-name-label") },
                model: {
                  value: _vm.content.companyName,
                  callback: function ($$v) {
                    _vm.$set(_vm.content, "companyName", $$v)
                  },
                  expression: "content.companyName",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { fancy: "", label: _vm.$ct("address-line-label") },
                model: {
                  value: _vm.content.addressLine1,
                  callback: function ($$v) {
                    _vm.$set(_vm.content, "addressLine1", $$v)
                  },
                  expression: "content.addressLine1",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { fancy: "", label: _vm.$ct("postal-and-place-label") },
                model: {
                  value: _vm.content.postalAndPlace,
                  callback: function ($$v) {
                    _vm.$set(_vm.content, "postalAndPlace", $$v)
                  },
                  expression: "content.postalAndPlace",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { fancy: "", label: _vm.$ct("tel-label") },
                model: {
                  value: _vm.content.tel,
                  callback: function ($$v) {
                    _vm.$set(_vm.content, "tel", $$v)
                  },
                  expression: "content.tel",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: {
                  fancy: "",
                  label: _vm.$ct("vat-no-label"),
                  "has-error": !_vm.vatIsValid && _vm.vatHasBeenBlured,
                },
                on: {
                  blur: function ($event) {
                    _vm.vatHasBeenBlured = true
                  },
                },
                model: {
                  value: _vm.content.vatNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.content, "vatNo", $$v)
                  },
                  expression: "content.vatNo",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { fancy: "", label: _vm.$ct("bank-label") },
                model: {
                  value: _vm.content.bank,
                  callback: function ($$v) {
                    _vm.$set(_vm.content, "bank", $$v)
                  },
                  expression: "content.bank",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: {
                  autocapitalize: "none",
                  fancy: "",
                  label: _vm.$ct("email-label"),
                },
                model: {
                  value: _vm.content.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.content, "email", $$v)
                  },
                  expression: "content.email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-button",
            {
              staticClass: "gray mt",
              attrs: { disabled: _vm.controlsDisabled },
              on: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("logout")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "mt",
              attrs: { disabled: _vm.controlsDisabled },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.continue")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }